import { render } from "./AlertComponent.vue?vue&type=template&id=ee0551f6&scoped=true"
import script from "./AlertComponent.vue?vue&type=script&lang=js"
export * from "./AlertComponent.vue?vue&type=script&lang=js"

import "@/assets/css/general/alert-style.css?vue&type=style&index=0&id=ee0551f6&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee0551f6"]])

export default __exports__